module.exports = __webpack_public_path__ + "img/corporateApply2.f60e7a04.png";